import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[enterPress]',
  standalone: true,
})
export class EnterPressDirective {
  // Input to accept a callback method
  @Input() enterPress!: (event?: Event) => void;

  constructor(private el: ElementRef) {}

  @HostListener('keydown.enter', ['$event'])
  onEnterPress(event: KeyboardEvent): void {
    event.preventDefault(); // Prevent the default behavior for Enter key (if needed)
    event.stopPropagation();
    if (this.enterPress && typeof this.enterPress == 'function') {
      // setTimeout(() => {
      //   this.el.nativeElement.parentNode.focus();
      // });

      this.enterPress(event); // Call the provided callback function
    }
  }
}
